import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * CLOUDWEB-18630
 * Р7-Офис Переключить на Р7 просмотр аттачей на sharing.mail.ru
 */

export const R7_FOR_SHARING_ATTACHES = isFeature('r7-for-sharing-attaches');
